<template>
  <!-- index.wxml -->
<div class="pi-user-tag" :class="size">
    <img class="pi-user-tag-icon" src="../../picture/my/my-type.png"
          alt="" v-if="vipType == 0" />
    <img class="pi-user-tag-icon" src="../../picture/my/my-type-2.png"
          alt="" v-if="vipType == 1" />
    <img class="pi-user-tag-icon" src="../../picture/my/my-type-3.png"
          alt="" v-if="vipType == 2" />
    <img class="pi-user-tag-icon" src="../../picture/my/my-type-4.png"
          alt="" v-if="vipType == 3" />
    <img class="pi-user-tag-icon" src="../../picture/my/my-type-5.png"
          alt="" v-if="vipType == 4" />
    <template v-if="userType == 2">
      
      <img class="pi-user-tag-icon" src="../../picture/my/ent-user.png"
           alt="" />

    </template>
    <template v-if="userType == 3">
      
      <img class="pi-user-tag-icon" src="../../picture/my/ent-pay.png"
           alt="" />
    </template>
    <template v-if="userType == 4">
      <img class="pi-user-tag-icon" src="../../picture/my/ent-pay.png"
           alt="" />
      <img class="pi-user-tag-admin" src="../../picture/my/ent-admin.png"
           alt="" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'pi-user-tag',
  data () {
    return {
      className: ''
    };
  },
  methods: {
  
  },
  mounted () {
  },
  props:{
    userType: {  // 普通会员/企业会员/企业支付/企业管理员
      type: Number,
      default: 1
    },
    vipType: {   // 普通会员/白银会员/黄金会员...
      type: Number,
      default: 0
    },
    size: {
      type:String,
      default: ''
    }
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.pi-user-tag .pi-user-tag-icon{
  width: 1.36rem;
  height: 0.34rem;
  vertical-align: top;
  margin-right: 0.10rem;
}
.pi-user-tag{
  display: inline-block;
}
.pi-user-tag-admin{
  width: 0.34rem;
  height: 0.34rem;
  display: inline-block;
  vertical-align: top;
}

</style>
